import { render } from "./EditCurrencyModal.vue?vue&type=template&id=477cef76"
import script from "./EditCurrencyModal.vue?vue&type=script&lang=js"
export * from "./EditCurrencyModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__